import {inject} from '~ui/store/store';

import {reducer, CurrentUserState} from './slice';

const KEY = 'user';

inject(KEY, reducer);

declare global {
    interface WikiState {
        [KEY]: CurrentUserState;
    }
}
